// Dropdown value
export const TRACK_CATEGORY_VALUE = "TRACK_CATEGORY_VALUE"
export const TRACK_CATEGORY_VALUE_SUCCESS = "TRACK_CATEGORY_VALUE_SUCCESS"
export const TRACK_CATEGORY_VALUE_ERROR = "TRACK_CATEGORY_VALUE_ERROR"

// Grid Data Value
export const PROFILE_DATA = "PROFILE_DATA"
export const PROFILE_DATA_SUCCESS = "PROFILE_DATA_SUCCESS"
export const PROFILE_DATA_ERROR = "PROFILE_DATA_ERROR"

// ADD NEW Profile
export const ADD_NEW_PROFILE = "ADD_NEW_PROFILE"
export const ADD_PROFILE_SUCCESS = "ADD_PROFILE_SUCCESS"
export const ADD_PROFILE_ERROR = "ADD_PROFILE_ERROR"

// Update Profile
export const UPDATE_PROFILE = "UPDATE_PROFILE"
export const UPDATE_PROFILE_SUCCESS = "UPDATE_PROFILE_SUCCESS"
export const UPDATE_PROFILE_ERROR = "UPDATE_PROFILE_ERROR"

export const UPDATE_WORK_REPORT = "UPDATE_WORK_REPORT"
export const UPDATE_WORK_REPORT_SUCCESS = "UPDATE_WORK_REPORT_SUCCESS"
export const UPDATE_WORK_REPORT_ERROR = "UPDATE_WORK_REPORT_ERROR"

export const DELETE_PROFILE = "DELETE_PROFILE"
export const DELETE_PROFILE_SUCCESS = "DELETE_PROFILE_SUCCESS"
export const DELETE_PROFILE_ERROR = "DELETE_PROFILE_ERROR"
